module.exports = __webpack_public_path__ + "media/notification.a2050abb.mp3";